export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=407f3dbc3de2658dd51afc84dda9eab88ecd7b2604&name=revalidateCommunity!'